<template>
  <ColorField
    v-model="context.value.value[props.field.key]"
    :field="props.field"
  />
</template>

<script setup lang="ts">
import { useFormKitContext } from '@formkit/vue'

import ColorField from '../ColorField.vue'
import type { SchemaFormKitProps } from './types'

const props = defineProps<SchemaFormKitProps>()
const context = useFormKitContext()
</script>

<style lang="scss">
.vc-compact {
  width: 247px !important;
}

.vc-compact > .vc-compact-colors {
  margin-left: 0em;
  margin-top: 0em;
}

.field .button.color-label-button {
  min-width: 175px;
  justify-content: left;
}
</style>
